import { MarketingNav } from "@/components/marketing-nav";
import { useIsTenantOrganizationSiteHost } from "@/lib/organization-site-host";
import { Outlet, createFileRoute } from "@tanstack/react-router";

function RouteComponent() {
  const isTenantOrganizationSite = useIsTenantOrganizationSiteHost();

  return (
    <>
      {!isTenantOrganizationSite ? <MarketingNav /> : null}
      <Outlet />
    </>
  );
}

export const Route = createFileRoute("/_marketing")({
  component: RouteComponent,
});
